import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
class List extends Component {
    render(){
        const { t } = this.props
        return (
            <div className="list-box">
                {
                    this.props.problemLists.map((item)=>(
                        <dl className="list-box-item" key={item.title}>
                            {/* <dt className="list-box-item_image"><img src={item.url} alt="" /></dt> */}
                            <dt className="list-box-item_image"></dt>
                            <dd className="list-box-item_text">
                                <h5 className="headline" onClick={()=>{this.props.handleClick(item.id)}}><span className="icon icon-problem"></span>{t(item.title)}</h5>
                                <div className="content">{t(item.content)}</div>
                            </dd>
                        </dl>
                    ))
                }
            </div>
        )
    }
}
export default withTranslation()(List)